import { Container, SimpleGrid, Heading, Body } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import InsuranceHeroButtons from './InsuranceHeroButtons';

const InsuranceHero: React.FC = () => (
  <Container
    maxW="1440px"
    pt={{ base: 700, desktop: 0 }}
    mb={{ base: 51, tablet: '72px' }}
  >
    <SimpleGrid columns={{ base: 1, desktop: 2 }}>
      <Container maxW="2xl" my="auto" px={{ base: 0, desktop: 500 }}>
        <Heading
          size={{ base: 600, tablet: 700, desktop: 800 }}
          style={{ marginBottom: 24 }}
          textAlign={{ base: 'center', desktop: 'left' }}
        >
          Get things back to normal faster.
        </Heading>
        <Body
          textAlign={{ base: 'center', desktop: 'left' }}
          size={500}
          maxW="md"
          mx={{ base: 'auto', desktop: 0 }}
          mb={700}
        >
          Make it faster and easier for homeowners to file a claim and get it
          approved.
        </Body>
        <InsuranceHeroButtons />
      </Container>
      <StaticImage
        quality={100}
        placeholder="blurred"
        height={1000}
        alt="insurance hero"
        src="../../../assets/images/insurance_hero.png"
      />
    </SimpleGrid>
  </Container>
);

export default InsuranceHero;
